import { FC, useEffect, useState } from "react";
import styles from "./styles.module.css";
import { useFoodConfig } from "../../hooks/useFood";
import Modal from "react-modal";
import { MdClose } from "react-icons/md";
import { Input } from "../inputs/inputs";
import { Slide, ToastContainer, toast } from "react-toastify";
import { useToast } from "../../hooks/useToast";
import api from "../../services/api";
import { usePluginspace } from "../../hooks/usePluginspace";
import ReactLoading from "react-loading";
import { OrderToSendType } from "../../contexts/OrderContext";
import { useOrder } from "../../hooks/useOrder";
import { v4 as uuidv4 } from "uuid";
import { useNavigate, useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { QrReader } from "../QrCodeReader/QrCodeReader";
import { CiCamera } from "react-icons/ci";
import { useConfig } from "../../pages/Auth/Auth";
import { useAppConfig } from "../../hooks/useAppConfig";
import { ModalFinalizaVendaFood } from "../ModalFinalizaVendaFood/modalFinalizaVendaFood";
import { arrayMessagesConnectionTotvs } from "../../functions/util";
import Swal from "sweetalert2";

const ModalFoodPedidoGarcom: FC<any> = () => {
  const {
    setOpenModal,
    openModal,
    typeModal,
    setTableNumber,
    tableNumber,
    cardNumber,
    isTable,
    isCard,
    customerName,
    setCallWaiter,
    callWaiter,
    customerPhone,
    verifyToOrder,
  } = useFoodConfig();
  const {
    clearOrder,
    generateDataToSendOrderCard,
    setReceipt,
    setOrderId,
    setOrderIdExt,
  } = useOrder();
  const { getToken } = usePluginspace();
  const [changeTableNumber, setChangeTableNumber] = useState<boolean>(false);
  const [newTableNumber, setNewTableNumber] = useState<number>(0);
  const { config } = useAppConfig();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [openCamera, setOpenCamera] = useState<boolean>(false);
  const navigate = useNavigate();
  const location = useLocation();
  const toastComponent = useToast();
  const [openModalFinalizaVendaFood, setOpenModalFinalizaVendaFood] =
    useState(false);
  const [typeModalError, setTypeModalError] = useState<
    "process" | "error_payment" | "error_payment_totvs" | "error_connection"
  >("process");

  useEffect(() => {
    setNewTableNumber(tableNumber);
  }, [tableNumber]);

  async function makeOrder() {
    try {
      setIsLoading(true);
      const pluginspace_id = location.pathname.split("/")[1];

      if (config?.content.pdv.safeMode) {
        const isValid = await verifyToOrder();

        if (!isValid || !isValid.success) {
          setOpenModal(false);
          clearDeviceAndNavigate(pluginspace_id);
        }

        const status = isValid.data.status;

        let title;
        let text;

        switch (status) {
          case "closed":
            setIsLoading(false);
            if (isTable) {
              title = "Mesa Fechada";
              text =
                "Para fazer pedidos, solicite ao garçom que reabra a sua conta.";
            } else {
              title = "Comanda fechada";
              text =
                "Para fazer pedidos, solicite ao garçom que reabra a sua conta.";
            }
            setOpenModal(false);
            Swal.fire({
              icon: "info",
              title: title,
              text: text,
              confirmButtonText: "Ok",
            });
            return;
          case "payed":
            if (isTable) {
              title = "Mesa Paga";
              text =
                "Para fazer pedidos, leia novamente o Qrcode para fazer seus pedidos.";
            } else {
              title = "Comanda Paga";
              text =
                "Para fazer pedidos, leia novamente o Qrcode para fazer seus pedidos.";
            }

            setOpenModal(false);
            Swal.fire({
              icon: "info",
              title: title,
              text: text,
              confirmButtonText: "Ok",
            }).then(() => clearDeviceAndNavigate(pluginspace_id));
            return;
          case "removed":
            if (isTable) {
              title = "Acesso indisponível";
              text =
                "Essa mesa não está mais disponível, leia novamente o Qrcode para fazer seus pedidos.";
            } else {
              title = "Comanda indisponível";
              text =
                " Essa comanda não está mais disponível, solicite outra para fazer seus pedidos.";
            }

            setOpenModal(false);
            Swal.fire({
              icon: "info",
              title: title,
              text: text,
              confirmButtonText: "Ok",
            }).then(() => clearDeviceAndNavigate(pluginspace_id));
            return;
          case "active":
            // Add logic for 'active' status here
            break;
          default:
            // Handle unexpected status here
            break;
        }
      }

      localStorage.removeItem("removed_by_admin");
      localStorage.removeItem("removed_by_admin_table");

      if (isTable) {
        await sendOrderTable();
      }

      if (isCard) {
        await sendOrderCard();
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function callWaiterFunction() {
    try {
      setIsLoading(true);
      const pluginspace_id = location.pathname.split("/")[1];

      if (config?.content.pdv.safeMode) {
        const isValid = await verifyToOrder();

        if (!isValid || !isValid.success) {
          setOpenModal(false);
          clearDeviceAndNavigate(pluginspace_id);
        }

        const status = isValid.data.status;

        let title;
        let text;

        switch (status) {
          case "closed":
            setIsLoading(false);
            if (isTable) {
              title = "Mesa Fechada";
              text =
                "Para fazer pedidos, solicite ao garçom que reabra a sua conta.";
            } else {
              title = "Comanda fechada";
              text =
                "Para fazer pedidos, solicite ao garçom que reabra a sua conta.";
            }
            setOpenModal(false);
            Swal.fire({
              icon: "info",
              title: title,
              text: text,
              confirmButtonText: "Ok",
            });
            return;
          case "payed":
            if (isTable) {
              title = "Mesa Paga";
              text =
                "Para fazer pedidos, leia novamente o Qrcode para fazer seus pedidos.";
            } else {
              title = "Comanda Paga";
              text =
                "Para fazer pedidos, leia novamente o Qrcode para fazer seus pedidos.";
            }

            setOpenModal(false);
            Swal.fire({
              icon: "info",
              title: title,
              text: text,
              confirmButtonText: "Ok",
            }).then(() => clearDeviceAndNavigate(pluginspace_id));
            return;
          case "removed":
            if (isTable) {
              title = "Acesso indisponível";
              text =
                "Essa mesa não está mais disponível, leia novamente o Qrcode para fazer seus pedidos.";
            } else {
              title = "Comanda indisponível";
              text =
                " Essa comanda não está mais disponível, solicite outra para fazer seus pedidos.";
            }

            setOpenModal(false);
            Swal.fire({
              icon: "info",
              title: title,
              text: text,
              confirmButtonText: "Ok",
            }).then(() => clearDeviceAndNavigate(pluginspace_id));
            return;
          case "active":
            // Add logic for 'active' status here
            break;
          default:
            // Handle unexpected status here
            break;
        }
      }

      localStorage.removeItem("removed_by_admin");
      localStorage.removeItem("removed_by_admin_table");

      //setTableNumber(newTableNumber);

      if (!newTableNumber) {
        toastComponent.openToast("warning", "Inserir uma mesa valida!");
        return;
      }

      if (!callWaiter) {
        const response = await callWaiterRequest(newTableNumber);
        if (
          !response ||
          !response.SolicitarGarcomResult ||
          !response.SolicitarGarcomResult.Sucesso
        ) {
          toastComponent.openToast(
            "warning",
            "Um erro inesperado aconteceu, favor tentar novamente!"
          );
        } else {
          setCallWaiter(new Date());
          setOpenModal(false);
          toastComponent.openToast(
            "success",
            "Aguarde um momento, o garçom já está vindo!"
          );
        }
        // setTimeout(() => setOpenModal(false), 2000);
        return;
      }

      const now = new Date().getTime();
      const date = new Date(callWaiter).getTime();
      // Calcula a diferença em milissegundos
      const differenceInMilliseconds = now - date;
      // Converte a diferença para minutos
      const differenceInMinutes = differenceInMilliseconds / (1000 * 60);

      if (differenceInMinutes > 5) {
        const response = await callWaiterRequest(newTableNumber);

        if (!response || !response.success) {
          toastComponent.openToast(
            "warning",
            "Um erro inesperado aconteceu, favor tentar novamente!"
          );
        } else {
          setCallWaiter(new Date());
          toastComponent.openToast(
            "success",
            "Chamado enviado para a cozinha. Por favor aguarde, em breve iremos atender você!"
          );
        }
      } else {
        toastComponent.openToast(
          "warning",
          "O garçom já foi solicitado, aguarde."
        );
      }

      setTimeout(() => setOpenModal(false), 2000);
    } catch (error) {
      console.log(error);
      toastComponent.openToast(
        "warning",
        "Um erro inesperado aconteceu, favor tentar novamente!"
      );
    } finally {
      setIsLoading(false);
    }
  }

  async function callWaiterRequest(tableNumberParam?: number) {
    try {
      setIsLoading(true);
      const tableToUse = tableNumberParam || tableNumber;

      const response = await api
        .get(`api/order-food/call-waiter/${tableToUse}`, {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        })
        .then((res) => res.data)
        .catch((err) => err);

      setIsLoading(false);

      return response;
    } catch (error) {
      setIsLoading(false);
    }
  }

  async function sendOrderTable() {
    try {
      setIsLoading(true);
      const orderData: OrderToSendType | undefined =
        await generateDataToSendOrderCard(
          {
            name: customerName,
            id:0,
            cpf: "",
            telephone: customerPhone,
            acceptTermDate: new Date(),
          },
          "",
          uuidv4(),
          false
        );

      const params = new URLSearchParams(location.search);
      const pluginspace_id = location.pathname.split("/")[1];

      if (orderData && tableNumber && pluginspace_id) {
        const result = await sendOrderTableRequest(orderData, tableNumber);
        setIsLoading(false);
        if (result && result.success === true) {
          setOrderId(result.dados.orderId);
          setOrderIdExt(result.dados.orderidExt);
          clearOrder();
          setOpenModal(false);
          toastComponent.openToast("success", "Pedido enviado com sucesso!");
          if (config && config.content.pdv.showLayout === "l2") {
            navigate(`/${pluginspace_id}/products-new`);
          } else {
            navigate(`/${pluginspace_id}/products`);
          }
          // setTimeout(() => setOpenModal(false), 1000);
        } else {
          let message = "Não foi possível enviar o pedido";
          if (result && result.message) {
            message = result.message;

            if (result.message === "Mesa fechada.") {
              message =
                "Fechamento solicitado! Não é possível adicionar mais pedidos agora. Se precisar, fale com o garçom.";
            }
          }
          setOpenModal(false);
          toastComponent.openToast("warning", message, 12000);
        }
      } else {
        setIsLoading(false);
        setOpenModal(false);
        toastComponent.openToast(
          "error",
          "Não foi possível enviar o pedido",
          5000
        );
      }
    } catch (error) {
      toastComponent.openToast(
        "error",
        "Não foi possível enviar o pedido",
        5000
      );
      setIsLoading(false);
      setTimeout(() => setOpenModal(false), 1000);
    }
  }

  async function sendOrderTableRequest(
    orderData: any,
    table_number: number,
    attempts: number = 1
  ) {
    try {
      return await api
        .post(
          "/api/orders/send-food-order",
          { ...orderData, tableNumber: table_number },
          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          }
        )
        .then((response) => {
          setOpenModalFinalizaVendaFood(false);
          return response.data;
        })
        .catch(async (err) => {
          if (
            err.response &&
            err.response.data &&
            arrayMessagesConnectionTotvs.includes(err.response.data.message)
          ) {
            err.response.data.message =
              "Não foi possível enviar o seu pedido, por favor dirija-se ao caixa.";
            if (attempts < 3) {
              if (attempts === 1) {
                setIsLoading(false);
                setOpenModalFinalizaVendaFood(true);
                setTypeModalError("error_connection");
              }
              await new Promise((resolve, reject) => setTimeout(resolve, 5000));
              const responseSend: any = await sendOrderTableRequest(
                orderData,
                table_number,
                attempts + 1
              );
              if (responseSend && responseSend.success) {
                setOpenModalFinalizaVendaFood(false);
                return responseSend;
              }
            } else {
              setOpenModalFinalizaVendaFood(false);
            }
          }
          setOpenModalFinalizaVendaFood(false);
          return err.response ? err.response.data : null;
        });
    } catch (error) {
      return null;
    }
  }

  async function sendOrderCard() {
    try {
      setIsLoading(true);
      const orderData: OrderToSendType | undefined =
        await generateDataToSendOrderCard(
          {
            name: customerName,
            cpf: "",
            id:0,
            telephone: customerPhone,
            acceptTermDate: new Date(),
          },
          "",
          uuidv4(),
          false
        );
      const pluginspace_id = location.pathname.split("/")[1];

      //setTableNumber(newTableNumber);

      if (
        !newTableNumber ||
        Number(newTableNumber) <= 0 ||
        isNaN(Number(newTableNumber))
      ) {
        toastComponent.openToast("warning", "Insira um número de mesa válido");
        setIsLoading(false);
        return;
      }

      if (orderData && newTableNumber && pluginspace_id && cardNumber) {
        const result = await sendOrderCardRequest(
          orderData,
          newTableNumber,
          cardNumber
        );
        setIsLoading(false);
        if (result && result.success === true) {
          setOrderId(result.dados.orderId);
          setOrderIdExt(result.dados.orderidExt);
          clearOrder();
          setOpenModal(false);
          toastComponent.openToast("success", "Pedido enviado com sucesso!");
          if (config && config.content.pdv.showLayout === "l2") {
            navigate(`/${pluginspace_id}/products-new`);
          } else {
            navigate(`/${pluginspace_id}/products`);
          }
          // setTimeout(() => setOpenModal(false), 1000);
        } else {
          let message = "Não foi possível enviar o pedido";
          if (result && result.message) {
            message = result.message;

            if (result.message === "Mesa fechada.") {
              message =
                "Fechamento solicitado! Não é possível adicionar mais pedidos agora. Se precisar, fale com o garçom.";
            }
          }
          setOpenModal(false);
          toastComponent.openToast("warning", message, 12000);
        }
      } else {
        setIsLoading(false);
        setOpenModal(false);
        toastComponent.openToast("error", "Não foi possível enviar o pedido");
      }
    } catch (error) {
      toastComponent.openToast("error", "Não foi possível enviar o pedido");
      setIsLoading(false);
    }
  }

  async function sendOrderCardRequest(
    orderData: any,
    table_number: number,
    card_number: number,
    attempts: number = 1
  ) {
    try {
      return await api
        .post(
          "/api/orders/send-food-order",
          { ...orderData, tableNumber: table_number, cardNumber: card_number },
          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          }
        )
        .then((response) => {
          setOpenModalFinalizaVendaFood(false);
          return response.data;
        })
        .catch(async (err) => {
          if (
            err.response &&
            err.response.data &&
            arrayMessagesConnectionTotvs.includes(err.response.data.message)
          ) {
            err.response.data.message =
              "Não foi possível enviar o seu pedido, por favor dirija-se ao caixa.";
            if (attempts < 3) {
              if (attempts === 1) {
                setIsLoading(false);
                setOpenModalFinalizaVendaFood(true);
                setTypeModalError("error_connection");
              }
              await new Promise((resolve, reject) => setTimeout(resolve, 5000));
              const responseSend: any = await sendOrderCardRequest(
                orderData,
                table_number,
                card_number,
                attempts + 1
              );
              if (responseSend && responseSend.success) {
                setOpenModalFinalizaVendaFood(false);
                return responseSend;
              }
            } else {
              setOpenModalFinalizaVendaFood(false);
            }
          }
          setOpenModalFinalizaVendaFood(false);
          return err.response ? err.response.data : null;
        });
    } catch (error) {
      return null;
    }
  }

  function readQrcode(value: string) {
    try {
      if (value && value.includes("/table/")) {
        const link = value.split("/table/")[1];

        if (link) {
          const tableNumber = link.split("/")[0];

          if (tableNumber) {
            setNewTableNumber(parseInt(window.atob(tableNumber)));
            setOpenCamera(false);
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function clearDeviceAndNavigate(pluginspace_id: string) {
    clearOrder();
    setIsLoading(false);
    localStorage.removeItem("reload_app_food");
    navigate(`/${pluginspace_id}?kicked=true`, { replace: true });
  }

  return (
    <>
      <Modal
        isOpen={openModal && !openModalFinalizaVendaFood}
        onRequestClose={() => setOpenModal(false)}
        className={styles.modal}
        contentLabel={typeModal}
        overlayClassName="overlay-modal"
        ariaHideApp={false}
      >
        <div className={styles.modal_body}>
          <div className={styles.modal_content_main}>
            <div className={styles.modal_content}>
              <div className={styles.modal_header}>
                <h4>
                  {typeModal === "Enviar pedido"
                    ? "Enviar pedido"
                    : "Precisa de ajuda?"}
                </h4>
                <MdClose
                  size={"24px"}
                  onClick={() => {
                    !isLoading && setOpenModal(false);
                  }}
                />
              </div>

              <div className={styles.body}>
                <span>
                  {" "}
                  {typeModal === "Enviar pedido"
                    ? "O seu pedido será enviado para a cozinha. Por favor confirme os dados abaixo."
                    : isTable
                      ? `Ao clicar no botão abaixo, um garçom será chamado para te atender!`
                      : "Para enviar um alerta para a cozinha, por favor informe a sua mesa."}
                </span>

                <div className={styles.info_customer}>
                  {config?.content.pdv.safeMode && (
                    <div className={styles.info}>
                      <span className={styles.info_title}> Nome: </span>
                      <span>{customerName}</span>
                    </div>
                  )}

                  {isCard && (
                    <div
                      className={styles.info_with_input}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "start",
                      }}
                    >
                      <div>
                        {newTableNumber ? (
                          <></>
                        ) : (
                          <span style={{ color: "red" }}>
                            Informe o número da mesa
                          </span>
                        )}
                      </div>
                      <div
                        style={{
                          display: "flex",
                          gap: "8px",
                          alignItems: "center",
                        }}
                      >
                        <span className={styles.info_title}> Mesa: </span>

                        <>
                          <Input
                            inputAttr={{
                              type: "default",
                            }}
                            textCenter
                            isSmall
                            height="30px"
                            label=""
                            name="Número da Mesa"
                            placeholder="0"
                            value={newTableNumber ? newTableNumber : ""}
                            change={(value: string) => {
                              if (value.length <= 4) {
                                if (
                                  value.trim() === "" ||
                                  isNaN(Number(value))
                                ) {
                                  setNewTableNumber(0);
                                } else if (Number(value) > 0) {
                                  setNewTableNumber(Number(value));
                                } else {
                                  toastComponent.openToast(
                                    "warning",
                                    "O número da mesa deve ser maior que 0."
                                  );
                                }
                              }
                            }}
                          />
                          <div
                            className={styles.button_camera}
                            onClick={() => {
                              setOpenCamera(true);
                            }}
                          >
                            <CiCamera />
                          </div>
                        </>
                      </div>
                    </div>
                  )}

                  {isCard && (
                    <div className={styles.info}>
                      <span className={styles.info_title}> Comanda: </span>
                      <span>{cardNumber}</span>
                    </div>
                  )}

                  {isTable && (
                    <div className={styles.info}>
                      <span className={styles.info_title}> Mesa: </span>
                      <span>{tableNumber}</span>
                    </div>
                  )}
                </div>

                <button
                  onClick={() => {
                    typeModal === "Chamar Garçom"
                      ? callWaiterFunction()
                      : makeOrder();
                  }}
                  disabled={isLoading || (isCard && !newTableNumber)}
                  className={`${isLoading && styles.is_loading} ${isCard && !newTableNumber && styles.is_loading
                    }`}
                >
                  {" "}
                  {typeModal === "Enviar pedido"
                    ? "Enviar"
                    : "Chamar garçom"}{" "}
                  {isLoading && (
                    <ReactLoading
                      type={"spin"}
                      color={"#FFFFFF"}
                      height={"25px"}
                      width={"25px"}
                    />
                  )}{" "}
                </button>
              </div>
            </div>
          </div>
        </div>
        {openCamera && <QrReader setScannedResult={readQrcode} />}
      </Modal>
      <ModalFinalizaVendaFood
        isOpen={openModalFinalizaVendaFood}
        setOpenModal={setOpenModalFinalizaVendaFood}
        typeModal={typeModalError}
      />
    </>
  );
};

export { ModalFoodPedidoGarcom };

const ArrowRotate: FC = () => (
  <svg
    width="12"
    height="11"
    viewBox="0 0 12 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.20312 3.90625C2.0625 4.1875 1.73438 4.30469 1.45312 4.1875C1.17188 4.07031 1.03125 3.74219 1.14844 3.46094C1.94531 1.58594 3.82031 0.25 6 0.25C7.21875 0.25 8.39062 0.742188 9.25781 1.60938L9.375 1.72656L10.1953 0.882812C10.3594 0.71875 10.5703 0.625 10.7812 0.625C11.25 0.625 11.625 1 11.625 1.46875V4.1875C11.625 4.51562 11.3672 4.75 11.0625 4.75H8.32031C7.85156 4.75 7.5 4.39844 7.5 3.92969C7.5 3.71875 7.57031 3.50781 7.73438 3.34375L8.57812 2.5L8.46094 2.40625C7.80469 1.75 6.91406 1.375 6 1.375C4.28906 1.375 2.8125 2.42969 2.20312 3.90625ZM10.8281 7.58594C10.0078 9.4375 8.15625 10.75 6 10.75C4.75781 10.75 3.58594 10.2812 2.71875 9.39062L2.625 9.29688L1.78125 10.1406C1.61719 10.3047 1.40625 10.375 1.19531 10.375C0.726562 10.375 0.375 10.0234 0.375 9.55469V6.8125C0.375 6.50781 0.609375 6.25 0.9375 6.25H3.65625C4.125 6.25 4.5 6.625 4.5 7.09375C4.5 7.30469 4.40625 7.51562 4.24219 7.67969L3.42188 8.5L3.51562 8.61719C4.17188 9.27344 5.0625 9.625 6 9.625C7.6875 9.625 9.16406 8.61719 9.77344 7.14062C9.91406 6.83594 10.2422 6.71875 10.5234 6.83594C10.8047 6.95312 10.9453 7.28125 10.8281 7.58594ZM10.5 3.625V2.17188L9.02344 3.625H10.5ZM1.5 7.375V8.85156L2.95312 7.375H1.5Z"
      fill="#6E7586"
    />
  </svg>
);
